export default __webpack_public_path__ + "static/media/management.7d9b58d6.svg";